import { rest } from '@0xtorch/core'
import { z } from 'zod'
import { createSha256Hash } from '../../utils/createSha256Hash'
import { fetchAllData } from '../../utils/fetchAllData'
import { binanceApiEndpoint } from '../constants'
import type { Trade } from './schema'
import { tradeSchema } from './schema'

const responseSchema = z.array(tradeSchema)

type FetchAllSpotTradeHistoriesParameters = {
  readonly apiKey: string
  readonly apiSecret: string
  readonly symbol: string
  readonly from: number
  readonly to: number
  readonly proxy?: string
}

const urlPath = '/api/v3/myTrades'

export const fetchAllSpotTradeHistories = ({
  apiKey,
  apiSecret,
  symbol,
  from,
  to,
  proxy,
}: FetchAllSpotTradeHistoriesParameters): Promise<readonly Trade[]> =>
  fetchAllData({
    from,
    to,
    limit: 1000,
    desc: false,
    idKey: 'id',
    timestampKey: 'time',
    interval: 100,
    fetchData: async ({ from, limit, desc }) => {
      if (desc) {
        throw new Error('desc must be false')
      }
      if (limit > 1000) {
        throw new Error('limit must be less than or equal to 1000')
      }

      const url = new URL(urlPath, binanceApiEndpoint)
      url.searchParams.append('timestamp', Date.now().toString())
      url.searchParams.append('symbol', symbol)
      url.searchParams.append('limit', limit.toString())
      if (from !== undefined) {
        url.searchParams.append('startTime', from.toString())
      }
      // if (to !== undefined) {
      //   url.searchParams.append('endTime', to.toString())
      // }
      url.searchParams.append(
        'signature',
        await createSha256Hash(url.searchParams.toString(), apiSecret),
      )

      const response = await rest(
        proxy === undefined
          ? url.toString()
          : `${proxy}${encodeURIComponent(url.toString())}`,
        {
          fetchOptions: {
            method: 'GET',
            headers: {
              'X-MBX-APIKEY': apiKey,
            },
          },
          schema: responseSchema,
        },
      )

      return response
    },
  })
